import React from 'react';
import { Box } from '@material-ui/core';

interface HintTextProps {
  text: string;
}

export const HintText = (props: HintTextProps) => (
  <Box color="text.secondary" fontSize={15} pb={1} whiteSpace="pre-wrap">
    {props.text}
  </Box>
);
